import { ErrorText } from "../shared/styledComponents";

const ErrorMessage = () => {
  return (
    <ErrorText>
      An error has occurred...
    </ErrorText>
  )
}


export default ErrorMessage;
